export default __webpack_public_path__ + "static/media/39.0591392e.jpg";